import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";

import localesReducer from "src/entities/locales/model/localesSlice";
import careersReducer from "src/entities/careers/model/careersSlice";
import blogsReducer from "src/entities/blogs/model/blogsSlice";
import contactReducer from "src/entities/contact/model/contactSlice";
import modalReducer from "src/entities/modal/model/modalSlice";
import authReducer from "src/entities/auth/model/authSlice";

const appReducer = combineReducers({
  locales: localesReducer,
  careers: careersReducer,
  blogs: blogsReducer,
  contact: contactReducer,
  modal: modalReducer,
  auth: authReducer,
});

const rootReducer = (
  state: ReturnType<typeof appReducer>,
  action: AnyAction,
) => {
  if (action.type === "store/reset") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
